var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonListBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.99414,
    width: 12.0004,
    height: 1.7705,
    rx: 0.885251,
    fill: "#778797"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.33354,
    height: 1.7705,
    rx: 0.885251,
    fill: "#778797"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.99512,
    y: 7.11499,
    width: 12.0004,
    height: 1.7705,
    rx: 0.885251,
    fill: "#778797"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 7.11499,
    width: 3.33354,
    height: 1.7705,
    rx: 0.885251,
    fill: "#778797"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.99414,
    y: 14.2295,
    width: 12.0004,
    height: 1.7705,
    rx: 0.885251,
    fill: "#778797"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 14.2295,
    width: 3.33354,
    height: 1.7705,
    rx: 0.885251,
    fill: "#778797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonListBlack);
export default __webpack_public_path__ + "static/media/button_list-black.5dd925d220930adc4b9a6735072a3577.svg";
export { ForwardRef as ReactComponent };